import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ReferenceModel } from '../../models/ReferenceModel'


export interface ReferenceState {
    Reference: ReferenceModel
    ReferenceList: ReferenceModel[]
}

const initialState: ReferenceState = {
    Reference: {} as ReferenceModel,
    ReferenceList: [],
}

export const ReferenceSlice = createSlice({
    name: 'reference',
    initialState,
    reducers: {
        setReference: (state, action: PayloadAction<ReferenceModel[]>) => {
            state.ReferenceList = action.payload
        },
        saveReference: (state, action: PayloadAction<ReferenceModel>) => {
            let room = action.payload
            if (room.Id > 0) {
                let defaultModel: ReferenceModel = { Id: 0, ReferenceName: room.ReferenceName }
                let currentRoom =
                    state.ReferenceList.find((c) => c.Id === room.Id) || defaultModel
                    currentRoom.ReferenceName = room.ReferenceName
            } else {
                room.Id = (Math.max(...state.ReferenceList.map((c) => c.Id)) || 0) + 1
                state.ReferenceList.push(room)
            }
        },
        getReferenceById: (state, action: PayloadAction<number>) => {
            let id = action.payload
            let Reference: ReferenceModel = {} as ReferenceModel
            if (id > 0) {
                let currentReference: ReferenceModel[] = state.ReferenceList
                Reference = currentReference.find((c) => c.Id === id) || ({} as ReferenceModel)
            }

            state.Reference = Reference
        },
        deleteReference: (state, action: PayloadAction<string>) => {
            let id: string = action.payload
            let ids: number[] = id.split(',').map((i) => parseInt(i))
            if (ids && ids.length > 0) {
                let currentReference: ReferenceModel[] = state.ReferenceList
                state.ReferenceList = currentReference.filter((c) => !ids.includes(c.Id))
            }
        },
    },
})

export const { setReference, saveReference, getReferenceById, deleteReference } =
ReferenceSlice.actions

export default ReferenceSlice.reducer
